import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

import { cn } from "../../lib/utils";

const DataTable = ({ data, className }) => {
  const formatNumber = (num) =>
    new Intl.NumberFormat("en-US").format(num);

  const formatCurrency = (num) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num);

  const formatPercent = (num) => `${num.toFixed(2)}%`;

  return (
    <div className={cn("glass-card overflow-hidden animate-fade-in", className)}>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-border hover:bg-transparent">
              <TableHead>Name</TableHead>
              <TableHead className="text-right">Impressions</TableHead>
              <TableHead className="text-right">Clicks</TableHead>
              <TableHead className="text-right">CTR</TableHead>
              <TableHead className="text-right">Conversions</TableHead>
              <TableHead className="text-right">Revenue</TableHead>
              <TableHead className="text-right">Spend</TableHead>
              <TableHead className="text-right">ROAS</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={row.id}
                className="border-border hover:bg-secondary/50 transition-colors animate-slide-up"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <TableCell className="font-medium">{row.name}</TableCell>
                <TableCell className="text-right font-mono text-sm">
                  {formatNumber(row.impressions)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm">
                  {formatNumber(row.clicks)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm text-primary">
                  {formatPercent(row.ctr)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm">
                  {formatNumber(row.conversions)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm text-success">
                  {formatCurrency(row.revenue)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm text-warning">
                  {formatCurrency(row.spend)}
                </TableCell>
                <TableCell className="text-right font-mono text-sm">
                  <span
                    className={cn(
                      "px-2 py-1 rounded-md text-xs font-semibold",
                      row.roas >= 3
                        ? "bg-success/20 text-success"
                        : row.roas >= 2
                        ? "bg-primary/20 text-primary"
                        : row.roas >= 1
                        ? "bg-warning/20 text-warning"
                        : "bg-destructive/20 text-destructive"
                    )}
                  >
                    {row.roas.toFixed(2)}x
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default DataTable;
